import _ from 'lodash';

const spring = require('../../assets/vendor/spring.js');

export default function gallupTracking(siteId) {
  const pathArray = window.location.pathname.split( '/');
  let cp = siteId;

  const page = !_.isEmpty(pathArray[1]) ? pathArray[1] : '';
  const sport = !_.isEmpty(pathArray[2]) ? pathArray[2] : '';
  const section = !_.isEmpty(pathArray[3]) ? pathArray[3] : '';

  if (sport && section) {
    cp = cp.concat(`/${sport}/${section}`);
  } else if (!sport && !section && page) {
    cp = cp.concat(`/${page}`);
  } else {
    cp = cp.concat('/forside');
  }

  window.springq = window.springq || [];
  window.springq.push({
    's': siteId,
    'cp': cp,
    'url': document.location.href,
  });

  const elementId = 'gallupTracking';
  if (!document.getElementById(elementId)) {
    const element = document.createElement('script');
    element.setAttribute('id', elementId);
    element.type = 'text/javascript';
    element.async = true;
    element.src = spring;

    const bodyFirstChild = document.getElementsByTagName('body')[0].firstChild;
    if (bodyFirstChild) bodyFirstChild.parentNode.insertBefore(element, bodyFirstChild);
  }
}



// WEBPACK FOOTER //
// ./src/util/gallupPageTracking.js